export default __webpack_public_path__ + "6c21bcdae43e22496d783e9577f984a7.svg";